import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {HttpService} from '../../../../services/http.service';
import {IDropdownSettings} from 'ng-multiselect-dropdown';
import {ContractType} from '../../../../models/warranties/contract-type.model';
import {Dealer} from '../../../../models/dealers/dealer.model';
import {AdminPromotion} from '../../../../models/promotions/admin-promotion.model';
import {ActivatedRoute, Router} from '@angular/router';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {FileUploader} from 'ng2-file-upload';
import {SweetUtil} from '../../../commons/sweet/sweet-util-service';
import {ToggleService} from '../../../../toggle/toggle.service';
import {UVDMServiceService} from '../../../../uvdm/uvdmservice.service';
import {FeatureToggle} from '../../../../toggle/feature-toggle';
import {environment} from '../../../../../environments/environment';

@Component({
  selector: 'app-promotion',
  templateUrl: './promotion.component.html',
  styleUrls: ['./promotion.component.scss']
})
export class PromotionComponent implements OnInit, OnDestroy {

  @ViewChild('contractType') contractType: HTMLInputElement;
  @ViewChild('contractCode') contractCode: HTMLInputElement;

  sub: any;

  vinList = '';
  dealerList: Dealer[];
  regions: string[];
  dealers: string[];
  models: string[];
  sources: string[] = ['Service Vehicles', 'Employee Lease', 'rental', 'exag', 'cafetariaplan', 'purchase', 'Other', 'Unknown'];
  uploadForm: UntypedFormGroup;
  uploader: FileUploader = new FileUploader({url: environment.baseUrl + '/upload/'});
  fileRemovals: string[] = [];

  contractTypes: ContractType[] = [];
  dropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'item_id',
    textField: 'item_text',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 6,
    allowSearchFilter: true
  };

  promotion: AdminPromotion = new AdminPromotion();
  discountError = '';
  descError = '';

  constructor(private http: HttpService, private route: ActivatedRoute, private router: Router,
              private fb: UntypedFormBuilder, private sweetUtil: SweetUtil, private toggleService: ToggleService,
              private uvdmService: UVDMServiceService) {
    this.uploadForm = this.fb.group({
      document: new UntypedFormControl(''),
      type: new UntypedFormControl('', Validators.compose([Validators.required]))
    });
  }

  ngOnInit(): void {
    this.toggleService.active(FeatureToggle.UVMS_PROMOTIONS).subscribe((active) => {
      if (active) {
        this.uvdmService.sourceChannels().subscribe((sourceChannels: Array<string>) => {
          if (this.sources) {
            this.sources.forEach(sourceChannel => sourceChannels.push(sourceChannel));
          }
          this.sources = sourceChannels;
        });
      }

    });


    this.http.fetchPromotionsRegions().subscribe((res) => {
      this.regions = Object.assign([], res);
    });
    this.http.fetchPromotionsDealers().subscribe((res: any[]) => {
      this.dealerList = Object.assign([], res);
      this.dealers = [];
      res.forEach(r => this.dealers.push(r.dealerNumber));
    });
    this.http.fetchPromotionModels().subscribe((res) => {
      this.models = [];
      res.forEach(m => {
        if (!this.models.includes(m.modelCode)) {
          this.models.push(m.modelCode);
        }
      });
    });

    this.fetchPromotions();
  }

  fetchPromotions(): void {
    this.sub = this.route.params.subscribe((p) => {
      if (p.id) {
        this.http.fetchAdminPromotion(p.id).subscribe((promo) => {
          this.promotion = Object.assign(new AdminPromotion(), promo);
          this.http.fetchPromotionContractTypes(this.promotion.selectedBrand).subscribe((contractTypes: ContractType[]) => {
            this.setContractTypes(contractTypes);
            this.promotion.selectedContractType = this.contractTypes.find(c => this.promotion.selectedContractType &&
              (c.contractType === this.promotion.selectedContractType.contractType));
            this.promotion.selectedVins.forEach(v => this.vinList += v + '\n');
          });
        });
      }
    });
  }

  setContractTypes(contractTypes: ContractType[]): void {
    this.contractTypes = [];
    const contractTypeNames = [];
    contractTypes.forEach((contractType: ContractType) => {
      if (contractTypeNames.includes(contractType.contractType)) {

      } else {
        this.contractTypes.push(contractType);
      }
      contractTypeNames.push(contractType.contractType);
    });
  }

  selectAllDealersInSelectedRegions() {
    let tempDealers: Dealer[] = [];
    const tempSelected: string[] = [];
    this.promotion.selectedRegions.forEach(r => {
      tempDealers = this.dealerList.filter(d => d.dealerRegion === r);
      this.promotion.selectedDealers = [];
      tempDealers.forEach(t => {
        tempSelected.push(t.dealerNumber);
      });
      tempSelected.forEach(t => this.promotion.selectedDealers.push(t));
    });
  }

  fetchContractTypes() {
    this.http.fetchPromotionContractTypes(this.promotion.selectedBrand).subscribe((contractTypes: ContractType[]) => {
      this.setContractTypes(contractTypes);
    });
  }

  setContractDurations() {
    this.promotion.selectedContractCode = null;
  }

  savePromotion() {
    if (!this.isValid()) {
      return;
    }

    if (this.vinList) {
      this.promotion.selectedVins = this.vinList.split('\n');
    }

    this.http.savePromotion(this.promotion).subscribe((res: any) => {
      if (this.promotion.id !== 0 && this.fileRemovals.length > 0) {
        this.http.removeFiles(this.promotion.id, this.fileRemovals).subscribe(() => {
        });
      }

      const files: FormData = new FormData();
      for (let i = 0; i < this.uploader.queue.length; i++) {
        const fileItem = this.uploader.queue[i]._file;
        if (fileItem.size > 10000000) {
          alert('Each File should be less than 10 MB of size.');
          return;
        }
      }

      for (let j = 0; j < this.uploader.queue.length; j++) {
        const fileItem = this.uploader.queue[j]._file;
        files.append('file', fileItem);
        files.append('fileSeq', 'seq' + j);
        files.append('dataType', this.uploadForm.controls.type.value);
      }

      if (files.has('file')) {
        this.http.postFiles(files, res.id).subscribe(() => {
          this.uploader.clearQueue();
          SweetUtil.showSuccess('Promotion published').then();
          this.goBack();
        }, err => {
          if (err.status === 406) { // Files contained Viruses
            SweetUtil.showWarning('Some files were found to be invalid and have not been saved.').then();
            this.goBack();
          } else {
            console.error(err);
            this.sweetUtil.showError('There was a problem saving this post. Please try again.').then();
            console.error(JSON.stringify(err));
          }
        });
      } else {
        SweetUtil.showSuccess('Promotion published').then();
        this.goBack();
      }

    });
  }

  isValid(): boolean {
    if (!this.promotion.description) {
      this.descError = 'Please provide a description';
      return false;
    }
    if (!this.promotion.discount || isNaN(this.promotion.discount) || this.promotion.discount === 0) {
      this.discountError = 'Invalid Discount Amount';
      return false;
    }
    return true;
  }

  removeFile(filename: string, type: string) {
    this.fileRemovals.push(filename);
    switch (type) {
      case 'doc':
        this.promotion.documentUrls.splice(this.promotion.documentUrls.indexOf(filename), 1);
        break;
      default:
        break;
    }
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  goBack() {
    window.history.back();
  }

  deletePromotion() {
    SweetUtil.getConfirm('Delete Promotion?', ' Are you sure you want to remove this promotion?').then((res) => {
      if (res.value) {
        this.http.deletePromotion(this.promotion.id).subscribe(() => {
          this.goBack();
        });
      }
    });
  }
}
